import { render, staticRenderFns } from "./AchievementCard.vue?vue&type=template&id=1fdbb9ba&scoped=true&"
import script from "./AchievementCard.vue?vue&type=script&lang=js&"
export * from "./AchievementCard.vue?vue&type=script&lang=js&"
import style0 from "./AchievementCard.vue?vue&type=style&index=0&id=1fdbb9ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdbb9ba",
  null
  
)

export default component.exports